import { AlertKind, Area } from '@/models/WeatherWarning'

export type WeatherWarningHistoryItemAttrs = {
  kinds: AlertKind[]
  publishingOffice: string
  area: Area
  areaCode: string
  updatedAt: string
  targetTime: string
}

export type WeatherWarningHistoryAttrs = WeatherWarningHistoryItemAttrs[]

export class WeatherWarningHistoryItem {
  public kinds: AlertKind[]
  public publishingOffice: string
  public area: Area
  public areaCode: string
  public updatedAt: string
  public targetTime: string

  constructor(item: WeatherWarningHistoryItemAttrs) {
    this.kinds = item.kinds
    this.publishingOffice = item.publishingOffice
    this.area = item.area
    this.areaCode = item.areaCode
    this.updatedAt = item.updatedAt
    this.targetTime = item.targetTime
  }

  public findKind(code: string) {
    return this.kinds.find(kind => kind.code === code)
  }
}

export default class WeatherWarningHistory {
  public weatherWarningData: WeatherWarningHistoryItem[]

  constructor(attrs: WeatherWarningHistoryAttrs) {
    this.weatherWarningData = attrs.map(itemAttrs => {
      return new WeatherWarningHistoryItem(itemAttrs)
    })
  }
}
